import { cloneDeep, set, get } from "lodash-es";
import { getCompMeta } from '../index';
export const replace = ({
  ctx,
  sourceLayout,
  targetCompId,
  targetLayout
}) => {
  const newLayout = !targetLayout ? cloneDeep(sourceLayout) : targetLayout;
  const sourceMeta = getCompMeta(ctx, sourceLayout.type);
  const targetMeta = getCompMeta(ctx, targetCompId);
  const getTargetReplaceTag = tag => targetMeta.propsSchema.fields.find(field => get(field, 'replaceTag') === tag);
  // 相同replaceTag 但是不同id 进行props迁移
  Object.keys(sourceLayout.props).forEach(key => {
    const sourceField = sourceMeta.propsSchema.fields.find(field => field.id === key);
    const sourceReplaceTag = get(sourceField, 'replaceTag');
    if (!sourceReplaceTag || !sourceField) return;
    const targetField = getTargetReplaceTag(sourceReplaceTag);
    if (!targetField || !targetField.id || !sourceField.id) return;
    set(newLayout, ['props', targetField.id], sourceLayout.props[sourceField.id]);
  });
  return {
    layout: newLayout
  };
};